import styles from "./FooterButton.module.css";
import React, { ReactElement } from "react";
import { ActionFooter, Button } from "@justworkshr/milo-components";

export interface FooterButtonProps {
  disabled?: boolean;
  handleBackClick?: () => void;
  handleNextClick?: () => void;
  nextButtonText?: string;
  backButtonText?: string;
  nextButtonHref?: string;
  backButtonHref?: string;
  hasOnlyBackButton?: boolean;
  hasOnlyNextButton?: boolean;
  buttonType?: "button" | "submit" | "reset" | undefined;
}

interface ILinkButtonProps {
  as?: "a" | "button";
  href?: string;
}

const FooterButton = ({
  disabled,
  handleBackClick,
  handleNextClick,
  nextButtonText,
  backButtonText,
  nextButtonHref,
  backButtonHref,
  hasOnlyBackButton = false,
  hasOnlyNextButton = false,
  buttonType = "submit",
}: FooterButtonProps): ReactElement => {
  const getLinkProps = (buttonHref?: string): ILinkButtonProps => {
    if (buttonHref) {
      return {
        as: "a",
        href: buttonHref,
      };
    }

    return { as: "button" };
  };

  const backLinkProps = getLinkProps(backButtonHref);
  const nextLinkProps = getLinkProps(nextButtonHref);

  const buttonList = hasOnlyBackButton
    ? [
        <Button
          variant="ghost"
          onClick={handleBackClick}
          type="button"
          key="back"
          {...backLinkProps}
        >
          {backButtonText}
        </Button>,
      ]
    : hasOnlyNextButton
    ? [
        <Button
          onClick={handleNextClick}
          disabled={disabled}
          type={buttonType}
          key="next"
          {...nextLinkProps}
        >
          {nextButtonText}
        </Button>,
      ]
    : [
        <Button
          variant="ghost"
          onClick={handleBackClick}
          type="button"
          key="back"
          {...backLinkProps}
        >
          {backButtonText}
        </Button>,
        <Button
          onClick={handleNextClick}
          disabled={disabled}
          type={buttonType}
          data-heap-id={nextButtonText}
          key="next"
          {...nextLinkProps}
        >
          {nextButtonText}
        </Button>,
      ];
  return (
    <ActionFooter
      className={styles.footerContainer}
      actions={buttonList}
      /*       secondary={[
        <Button
          variant="secondary"
          onClick={handleBackClick}
          disabled={disabled}
        >
          {backButtonText}
        </Button>,
      ]} */
    />
  );
};

export default FooterButton;
